import { getAuthParams } from '@/plugins/plugin-sso-login';
import { env } from '@/utils';
import { pick } from 'lodash';

export function paramsFormat(config) {
  const __allowEmpty = config?.params?.__allowEmpty; // 双下划线，允许当前接口可以传递空值
  config.params = Object.entries(config.params || {}).reduce((obj, item) => {
    // todo b_cfg-mgr_i18n 特殊处理逻辑 cr
    if (item[1] !== '' || __allowEmpty || item[0] === 'featureCountry') {
      obj[item[0]] = item[1];
    }
    delete obj['__allowEmpty'];
    return obj;
  }, {});
  if (config.method !== 'get') {
    config.data = config.params;
    delete config.params;
  } else {
    config.params[`t${new Date().getTime()}`] = 1;
  }
  return config;
}

/**
 * 识别gateway地址，自动转换请求配置
 * 将url替换成/gateway
 * 将api添加到params中
 */
export function transferConfig(url) {
  if (url.indexOf('http') !== -1 || url.indexOf('//:') !== -1) {
    return {
      transUrl: url,
      transParams: {},
    };
  }
  let transParams = {};
  let transUrl = url;
  // eslint-disable-next-line no-useless-escape
  const isGatewayReg = url.indexOf('.') !== -1;
  // eslint-disable-next-line no-useless-escape
  const isCommonGatewayReg = new RegExp('^common.', 'g');
  if (isGatewayReg) {
    if (isCommonGatewayReg.test(url)) {
      transUrl = '/common';
      transParams = {
        api: url,
      };
    } else {
      transUrl = '/gateway';
      transParams = {
        api: url,
      };
    }
  }
  return {
    transUrl,
    transParams,
  };
}

/**
 * 获取公共参数
 * 用户的country, timezone, locale, ticket
 * @returns {{[p: string]: *}}
 */
export function getCommonParams() {
  const userInfo = env.get('userInfo');
  const userParams = pick(userInfo, ['country', 'timezone', 'locale']);
  return {
    ...getAuthParams(),
    ...userParams,
  };
}
